import React from "react";
import PageWrapper from "./src/components/pageWrapper";

export function wrapPageElement(props) {
  return <PageWrapper {...props} />;
}
